import Switch from '@thanx/uikit/switch/Switch'
import { Text } from '@thanx/uikit/text'
import ModalContainer from 'components/ModalContainer'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import PopoverContent from '../PopoverContent'

const t = buildTranslate('redeem_manager.modifier_select')

type ItemsModalProps = {
  isOpen: boolean
  onClose: () => void
  title: string
  items: string[]
  menuNames: string[]
  optionPaths: string[]
  modifierUid: string
}

const ItemsModal = ({
  isOpen,
  onClose,
  title,
  items,
  menuNames,
  optionPaths,
  modifierUid,
}: ItemsModalProps) => {
  const [css] = useStyletron()

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      showBottomProceed={false}
      hideCancel
      title={title}
    >
      <div className="d-flex flex-column">
        <Text.BodyText4 color="grey70" className="mb-s">
          {t('learn_more_about_modifier')}
        </Text.BodyText4>

        <Text.BodyText4 color="grey50" className="mb-xs uppercase">
          <span className="mr-xs">{t('guid')}</span>
          <PopoverContent sections={[{ content: t('guid_info') }]} />
        </Text.BodyText4>
        <Text.BodyText4 color="grey70" className="mb-s">
          {modifierUid}
        </Text.BodyText4>

        <Switch condition={menuNames.length > 0}>
          <Text.BodyText4 color="grey50" className="mb-xs uppercase">
            {t('menus_title')}
          </Text.BodyText4>
          <Text.BodyText4 color="grey70">{t('menus_subtitle')}</Text.BodyText4>
          <ul
            aria-label="menus"
            className={`list-style-type-disc pl-m grey-70 ${css({
              maxHeight: '400px',
              overflowY: 'auto',
            })}`}
          >
            {menuNames.map(menuName => (
              <li className="mb-xs" key={menuName}>
                <Text.BodyText4 color="grey70">{menuName}</Text.BodyText4>
              </li>
            ))}
          </ul>
        </Switch>

        <Switch condition={Boolean(optionPaths)}>
          <Text.BodyText4 color="grey50" className="mb-xs uppercase">
            {t('modifier_groups_title')}
          </Text.BodyText4>
          <Text.BodyText4 color="grey70">
            {t('modifier_groups_subtitle')}
          </Text.BodyText4>
          <ul
            aria-label="paths"
            className={`list-style-type-disc pl-m grey-70 ${css({
              maxHeight: '400px',
              overflowY: 'auto',
            })}`}
          >
            {optionPaths.map(path => (
              <li className="mb-xs" key={path}>
                <Text.BodyText4 color="grey70">{path}</Text.BodyText4>
              </li>
            ))}
          </ul>
        </Switch>

        <Text.BodyText4 color="grey50" className="mb-xs uppercase">
          {t('items_in_modifier_modal_title')}
        </Text.BodyText4>
        <Text.BodyText4 color="grey70">
          {t('items_in_modifier_modal_subtitle')}
        </Text.BodyText4>
        <ul
          aria-label="items"
          className={`list-style-type-disc pl-m grey-70 ${css({
            maxHeight: '400px',
            overflowY: 'auto',
          })}`}
        >
          {items.map(item => (
            <li className="mb-xs" key={item}>
              <Text.BodyText4 color="grey70">{item}</Text.BodyText4>
            </li>
          ))}
        </ul>
      </div>
    </ModalContainer>
  )
}

export default ItemsModal
